import { Pipe, PipeTransform } from '@angular/core';
import { format as formatDate } from 'date-fns';

@Pipe({
  name: 'eventStartEndTime'
})
export class EventStartEndTimePipe implements PipeTransform {
  transform(eventItem: any): string {

    if (!eventItem.startDate) return '';

    let timeOutput  = '';

    // at a minimum, always return a date like... 12/05/2025 at 4:00 PM
    // timeOutput += formatDate(eventItem.startDate, 'MM/dd/yyyy at h:mm aa');
    timeOutput += formatDate(eventItem.startDate, 'MMM d, yyyy \'at\' h:mm aa')

    // if end date exists...
    if(eventItem.endDate) {
      const y_t = formatDate(new Date(), "yyyy"); // today year
      const y_e = formatDate(eventItem.endDate, "yyyy"); // end date year
      const ymd_s = formatDate(eventItem.startDate, 'yyyy-MM-dd'); // start date ymd
      const ymd_e = formatDate(eventItem.endDate, 'yyyy-MM-dd'); // end date ymd
      if(ymd_s === ymd_e) {
        // ...and if start and end date are on same day, return... 12/05/2025 from 4:00 PM - 6:00 PM
        timeOutput += ' – ' + formatDate(eventItem.endDate, 'h:mm aa');
        timeOutput = timeOutput.replace(' at ', ' from ');
      } else {
        // ...otherwise, return... 12/05/2025 at 4:00 PM - 12/10/2025 at 3:00 PM
        // timeOutput += ' – ' + formatDate(eventItem.endDate, 'MM/dd/yyyy at h:mm aa');
        timeOutput += ' – ' + formatDate(eventItem.endDate, 'MMM d, yyyy \'at\' h:mm aa');
      }
    }

    return timeOutput;
  }
}
